import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form, FormMessage, Button } from "lib/components/index";
import Dropzone from "react-dropzone";

import st from "lib/utils/index";
import { FormControl, HintView } from "lib/components/index";
import { stateSelector, updateProduct, uploadProductImages, save } from "../index";
import Hint from "./StepPhotosHint";
import ProductImagesFormSection from "./ProductImagesFormSection";

@connect(
  (state) => ({
    product: stateSelector(state).product,
    submitLoading: stateSelector(state).submitLoading,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        uploadProductImages,
        save,
      },
      dispatch
    )
)
export default class StepPhotosForm extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = { video_url: null };
  }

  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleProductImagesChange(product_images) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      product_images,
    });
  }

  handleFilesDrop(acceptedFiles, rejectedFiles) {
    const { uploadProductImages, product } = this.props;
    const attachments = acceptedFiles.map((file) => ({
      type: "Attachment::File",
      file,
      position: 1000,
    }));
    uploadProductImages(attachments);
  }

  handleVideoUploadSubmit() {
    const { uploadProductImages } = this.props;
    const { video_url } = this.state;
    if (!video_url) {
      return;
    }
    const attachments = [
      {
        type: "Attachment::Video",
        video_url,
        position: 0,
      },
    ];
    uploadProductImages(attachments);
  }

  render() {
    const { readOnlyAccess, product, submitLoading, valid, errors } = this.props;
    const { video_url } = this.state;

    return (
      <HintView.Container>
        <HintView.Content>
          <Form className="text" onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
            {!readOnlyAccess && (
              <div>
                <h2>{I18n.t("papp.products.EditProductView.StepPhotos.form_title")}</h2>

                {!!errors.base && <FormMessage error={errors.base} />}

                <Dropzone className="dropZone" onDrop={this.handleFilesDrop.bind(this)} accept="image/*">
                  <div>
                    <i className="material-icons icon">cloud_upload</i>
                    <p>{I18n.t("papp.products.EditProductView.StepPhotos.click_or_drag_and_drop_to_add_photos")}</p>
                  </div>
                </Dropzone>

                <br />

                {/* <div className="fields inline">
                  <label>{I18n.t("papp.products.EditProductView.StepPhotos.add_video")}</label>
                  <div className="field flexGrow">
                    <FormControl.Input
                      value={video_url}
                      onChange={video_url => this.setState({ video_url })}
                      className="fluid"
                      placeholder="np. https://youtube.com/watch?v=qvF7L1NmC3c"
                      type="url"
                    />
                  </div>
                  <Button as="a" primary
                    onClick={this.handleVideoUploadSubmit.bind(this)}
                    disabled={!video_url}
                    content={I18n.t("papp.products.EditProductView.StepPhotos.add_video_submit")}
                  />
                </div> */}

                <br />
              </div>
            )}

            <ProductImagesFormSection
              readOnlyAccess={readOnlyAccess}
              name={`product.product_images`}
              errors={errors}
              attachments={product.product_images}
              onChange={this.handleProductImagesChange.bind(this)}
            />

            <button type="submit" disabled={submitLoading} hidden />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPhotos/StepPhotosForm.jsx